import { useState, useEffect } from 'react';

const navItems = [
  { label: '实时快讯', href: '#updates' },
  { label: '常见问题', href: '#faq' },
  { label: '深度爆料', href: '#cards' },
  { label: '爆料投稿', href: '#contact' },
  { label: '平台优势', href: '#features' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a href="#" className="flex items-center gap-2 flex-shrink-0">
            <div className="w-8 h-8 md:w-9 md:h-9 bg-primary-500 rounded-lg flex items-center justify-center">
              <i className="ri-fire-line text-background-50 text-lg md:text-xl"></i>
            </div>
            <span className="text-lg md:text-xl font-bold font-heading text-foreground-950 whitespace-nowrap">
              黑料爆料
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            <a
              href="#"
              className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-md hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-md hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-secondary-200">
          <nav className="flex flex-col px-4 py-3 gap-1">
            <a
              href="#"
              onClick={() => setMobileOpen(false)}
              className="px-4 py-3 text-sm font-medium text-foreground-800 hover:bg-primary-50 rounded-md whitespace-nowrap cursor-pointer"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-sm font-medium text-foreground-800 hover:bg-primary-50 rounded-md whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}